import Vue from "vue";
import App from "./App.vue";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbvue/lib/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as mdbvue from "mdbvue";
import { Table, Navbar } from "buefy";
import "buefy/dist/buefy.css";
var SocialSharing = require("vue-social-sharing");

Vue.use(SocialSharing);
Vue.use(Table);
Vue.use(Navbar);

Vue.config.productionTip = false;

for (const component in mdbvue) {
  Vue.component(component, mdbvue[component]);
}

new Vue({
  render: (h) => h(App),
}).$mount("#app");
